function TileAccordion(params) {
    this.setDefaults(params);
    this.addListeners();
}

TileAccordion.prototype.setDefaults = function(params) {
    this.collapsedIcon = params.collapsedIcon;
    this.expandedIcon = params.expandedIcon;
    
    this.dom = {
        $container: params.container,
        $trigger: params.container.find(params.trigger)
    };
    
    this.collapsedHeight = this.dom.$container.height();
}

TileAccordion.prototype.addListeners = function() {
    this.dom.$trigger.on('click', this.toggleContent.bind(this))
}

TileAccordion.prototype.toggleContent = function() {
    if(this.dom.$container.height() === this.collapsedHeight) {
        this.dom.$container.css('height', this.dom.$container[0].scrollHeight);
        this.dom.$trigger.find('i').attr('class', this.expandedIcon);
    } else {
        this.dom.$container.css('height', this.collapsedHeight);
        this.dom.$trigger.find('i').attr('class', this.collapsedIcon);
    }
}

$('.wp-partnership-landing__tile').each(function(i, el){
    new TileAccordion({
        container: $(el),
        trigger: '.wp-partnership-landing__tile-title',
        collapsedIcon: 'fa fa-plus',
        expandedIcon: 'fa fa-minus'
    });
});